import { JsonRTEBlockProps } from '~/components/JsonRTEBlock/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';
import { camelCaseKeys } from '~/utils/camelCaseKeys';

import { JsonRTEBlock } from './models';

export const jsonRTEBlockMapper = (
  { pageBlockUI: [pageBlockUI], componentId, rte, showLoadMore, cta }: JsonRTEBlock,
  _id,
  { jsonRTEImages }: { jsonRTEImages: JsonRTEBlockProps['rteImages'] }
): JsonRTEBlockProps => ({
  pageBlockUI: pageBlockUIMapper(pageBlockUI.ui),
  componentId,
  rte: camelCaseKeys(rte),
  rteImages: jsonRTEImages,
  showLoadMore, cta
});
